// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const getTotalUsersCount = async (data) => {
  try {
    const resp = await HttpClient.get(`/users/counts/total-users`, {
      params: data,
    });

    if (!resp || !resp.data) {
      return {
        success: false,
        data: 0,
      };
    }
    return {
      success: true,
      data: resp.data.total,
    };
  } catch (error) {
    return {
      success: false,
      data: 0,
    };
  }
};

export const getUsersTotalActivitiesHours = async () => {
  try {
    const resp = await HttpClient.get(
      `/users/counts/users-by-activities-hours`
    );

    if (!resp || !resp.data) {
      return {
        success: false,
        data: [],
      };
    }
    return {
      success: true,
      data: resp.data.slice(0, 3),
    };
  } catch (error) {
    return {
      success: false,
      data: [],
    };
  }
};

export const getUsersByLastLogin = async (query = { limit: 3 }) => {
  try {
    const resp = await HttpClient.get(`/users/last-login`, { params: query });

    if (!resp || !resp.data) {
      return {
        success: false,
        data: [],
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
    };
  }
};
